import type { EntryPointRouteParams } from '@atlassian/jira-entry-points-plugin/src/common/types.tsx';
import parameters from '@atlassian/jira-relay/src/__generated__/NotificationLogsPageUiQuery$parameters';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const notificationsIssueLogsEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-software-notifications-issue-logs" */ './src'),
	),
	getPreloadProps: ({ context, tenantContext }: EntryPointRouteParams) => ({
		queries: {
			notificationLogs: {
				options: {
					fetchPolicy: 'network-only' as const,
				},
				parameters,
				variables: {
					cloudId: tenantContext.cloudId,
					projectId: Number(context?.query?.projectId ?? 0),
					notificationType: 'INTERNAL_NOTIFICATION_ISSUE',
				},
			},
		},
		extraProps: {
			accountId: tenantContext.atlassianAccountId,
			cloudId: tenantContext.cloudId,
			projectIds: context?.query?.projectId,
			projectKey: context?.match.params.projectKey,
		},
	}),
});
